import { Component, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';


@Component({
    
      selector: 'remove-dialog',
    
      template: `
    
      <p class="dialog-title"> {{data.title}} </p>
    
    
      <p> {{data.message}} </p>
  
    
      <button mat-button class="confirm-button" [mat-dialog-close]="true"> Remove </button>    
      <button mat-button mat-dialog-close> Close </button>
  
      `,
  
      styleUrls: ['./app-remove-dialog.component.scss']
    })
    
  export class RemoveDialogComponent {                           

      constructor(
    
        public dialogRef: MatDialogRef<RemoveDialogComponent>,        
    
        @Inject(MAT_DIALOG_DATA) public data: any) 
        {                          

        }  
    }


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/components/app-remove-dialog/app-remove-dialog.component.ts